<div class="col fo-p">
  <div class="is-centered is-fullwidth">
    @if (isGroupChat || audioUser) {
    <div
      class="tabsPanel"
      [ngClass]="{ 'is-active': tab_name === 'users' }"
      style="display: none"
    >
      <a>
        <span class="icon is-small">
          <i class="pi pi-users"></i>
        </span>
        <span
          >Users
          <a (click)="closeSideBarTab('users')" title="Close">
            <span class="icon is-small closeIcon">
              <i class="fa fa-times"></i>
            </span>
          </a>
        </span>
      </a>
    </div>
    } @if (!audioUser) {
    <div
      class="tabsPanel"
      [ngClass]="{ 'is-active': tab_name === 'files' }"
      style="display: none"
    >
      <a>
        <span class="icon is-small">
          <i class="fa fa-paperclip"></i>
        </span>
        <span
          >E Library
          <a (click)="closeSideBarTab('files')" title="Close">
            <span class="icon is-small closeIcon">
              <i class="fa fa-times"></i>
            </span>
          </a>
        </span>
      </a>
    </div>
    } @if (!audioUser) {
    <div
      class="tabsPanel"
      [ngClass]="{ 'is-active': tab_name === 'links' }"
      style="display: none"
    >
      <a>
        <span class="icon is-small">
          <i class="fa fa-link"></i>
        </span>
        <span
          >Links
          <a (click)="closeSideBarTab('links')" title="Close">
            <span class="icon is-small closeIcon">
              <i class="fa fa-times"></i>
            </span>
          </a>
        </span>
      </a>
    </div>
    } @if (!audioUser) {
    <div
      class="tabsPanel"
      [ngClass]="{ 'is-active': tab_name === 'tasks' }"
      style="display: none"
    >
      <a>
        <span class="icon is-small">
          <i class="fa fa-thumb-tack"></i>
        </span>
        <span
          >Assignment
          <a (click)="closeSideBarTab('tasks')" title="Close">
            <span class="icon is-small closeIcon">
              <i class="fa fa-times"></i>
            </span>
          </a>
        </span>
      </a>
    </div>
    } @if (audioUser) {
    <div
      class="tabsPanel"
      [ngClass]="{ 'is-active': tab_name === 'chats' }"
      style="display: none"
    >
      <a>
        <span class="icon is-small">
          <i class="fa fa-commenting"></i>
        </span>
        <span
          >Chats
          <a (click)="closeSideBarTab('chats')" title="Close">
            <span class="icon is-small closeIcon">
              <i class="fa fa-times"></i>
            </span>
          </a>
        </span>
      </a>
    </div>
    }
  </div>

  <!-- <div class="tabs is-centered is-fullwidth fourth-panel-tab">

  <ul>
    <li [ngClass]="{'is-active': tab_name === 'users'}" (click)="selectPanelMenu('users')" *ngIf="isGroupChat || audioUser">
      <a>
        <span class="icon is-small">
          <i class="fa fa-users"></i>
        </span>
        <span>Users</span>

      </a>
    </li>
    <li [ngClass]="{'is-active':  tab_name === 'files'}" (click)="selectPanelMenu('files')" *ngIf="!audioUser">
      <a>
        <span class="icon is-small">
          <i class="fa fa-paperclip"></i>
        </span>
        <span>Files

        </span>
      </a>
    </li>
    <li [ngClass]="{'is-active':  tab_name === 'links'}" (click)="selectPanelMenu('links')" *ngIf="!audioUser">
      <a>
        <span class="icon is-small">
          <i class="fa fa-link"></i>
        </span>
        <span>Links</span>
      </a>
    </li>
    <li [ngClass]="{'is-active':  tab_name === 'task'}" (click)="selectPanelMenu('task')" *ngIf="!audioUser">
      <a>
        <span class="icon is-small">
          <i class="fa fa-thumb-tack"></i>
        </span>
        <span>Task</span>
      </a>
    </li>
    <li [ngClass]="{'is-active':  tab_name === 'chats'}" (click)="selectPanelMenu('chats')" *ngIf="audioUser">
      <a>
        <span class="icon is-small">
          <i class="fa fa-commenting"></i>
        </span>
        <span>Chats</span>
      </a>
    </li>
  </ul>

</div> -->

  <!--  Listing group members section -->
  <!-- <ng-container *ngIf="showMemberList else nonMemberTemplate">
member
</ng-container>
<ng-template #nonMemberTemplate>
  Non member
</ng-template> -->

  @if (showMemberList && tab_name === 'users' && isGroupChat || showMemberList
  && tab_name === 'users' && audioUser) {
  <div
    class="list-wrapper scroll-bar list-overflow"
    appInfiniteScroll
    (reachedBottom)="
      onScrollDown(
        groupDetail?.chat_group_id,
        userDetail?.user_id,
        'allMemebers'
      )
    "
  >
    @if (groupDetail && groupDetail.can_edit) {
    <div class="menu-options level is-marginless display-flex">
      <div class="level-left"></div>
      <div class="level-right">
        <div class="level-item">
          <a
            class="is-small"
            title="Add More User"
            (click)="addNewMember(groupDetail?.chat_group_id, 0)"
          >
            <i class="fa fa-user-plus"></i>
          </a>
        </div>
      </div>
    </div>
    }
    <ul class="group-members">
      @for (user of groupMemberList; track user) {
      <li class="cursor-pointer pos-relative">
        <div class="columns is-gapless">
          <div class="column is-one-quarter">
            @if (!user.user_icon) {
            <empty-uname
              [userName]="user.full_name"
              [liProfile]="true"
            ></empty-uname>
            } @if (user.user_icon) {
            <img [src]="profileUrl + user.user_icon" class="image is-48x48" />
            }
            <span class="icon is-small">
              <i
                class="fa fa-circle"
                [ngClass]="{
                  'circle-grey': !user.is_online,
                  'circle-green': user.is_online
                }"
              ></i>
            </span>
          </div>
          <div class="column is-clearfix pos-relative">
            <div class="is-pulled-left">
              <span class="display-b"> {{ user.full_name }}</span>
              @if (user.is_online) {
              <p class="is-size-7 has-text-success">online</p>
              } @if (!user.is_online) {
              <p class="is-size-7 text-clr-grey">
                {{ user.last_seen | amTimeAgo }}
              </p>
              } @if (user.is_group_admin) {
              <a class="button is-primary is-outlined is-small time-ago"
                >Admin</a
              >
              }
            </div>
          </div>
        </div>
        @if (groupDetail && groupDetail.can_edit && !user.is_group_admin) {
        <div class="chat-close">
          <i
            class="fa fa-times"
            title="Remove Chat"
            (click)="
              removeGroupMemebers(groupDetail.chat_group_id, user.user_id)
            "
          ></i>
        </div>
        }
      </li>
      }
    </ul>
  </div>
  }

  <!-- Add new group members section  -->
  @if (!showMemberList) {
  <div
    class="list-wrapper scroll-bar list-overflow"
    appInfiniteScroll
    (reachedBottom)="
      onScrollDown(groupDetail.chat_group_id, userDetail?.user_id, 'newMembers')
    "
  >
    <div class="menu-options level is-marginless">
      <div class="level-left">
        <div class="level-item input-search-box">
          <div class="field">
            <p class="control has-icons-left">
              <input
                class="input"
                type="text"
                placeholder="Search"
                [(ngModel)]="search"
                (keyup)="searchInList.next($event)"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-search"></i>
              </span>
              <span class="input-bar"></span>
            </p>
            <div class="level-item">
              <a class="is-small pad-5" (click)="cancelNewGroupMemebers()">
                <i class="fa fa-close is-size-6"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="level-right">
      <div class="level-item">
        <a class="is-small pad-5" (click)="cancelNewGroupMemebers()">
          <i class="fa fa-close is-size-6"></i>
        </a>
      </div>
    </div> -->
    </div>
    <ul class="new-group-members">
      @for (nonUser of nonGroupUserList; track nonUser) {
      <li
        class="cursor-pointer pos-relative"
        [ngClass]="{ active: selectedUserIdList.indexOf(nonUser.user_id) > -1 }"
        (click)="selectNewGroupMembers(nonUser.user_id)"
      >
        <div class="columns is-gapless">
          <div class="column is-one-quarter">
            @if (!nonUser.user_icon) {
            <empty-uname
              [userName]="nonUser.full_name"
              [liProfile]="true"
            ></empty-uname>
            } @if (nonUser.user_icon) {
            <img [src]="profileUrl + nonUser.user_icon" />
            }
          </div>
          <div class="column is-clearfix pos-relative">
            <div class="is-pulled-left">
              <span class="display-b"> {{ nonUser.full_name }}</span>
              @if (nonUser.is_online) {
              <p class="is-size-7 has-text-success">online</p>
              } @if (!nonUser.is_online) {
              <p class="is-size-7 text-clr-grey">
                {{ nonUser.last_seen | amTimeAgo }}
              </p>
              }
            </div>
          </div>
        </div>
        <!-- <div class="chat-close">
        <i class="fa fa-check"></i>
      </div> -->
        @if (selectedUserIdList.indexOf(nonUser.user_id) > -1) {
        <div class="chat-check">
          <i class="fa fa-check"></i>
        </div>
        }
      </li>
      }
    </ul>
  </div>
  }
  <!--  End -->

  @if (tab_name === 'files') {
  <div
    class="list-wrapper scroll-bar list-overflow file-list-sec"
    appInfiniteScroll
    (reachedBottom)="
      onScrollDown(groupDetail.chat_group_id, userDetail?.user_id, 'files')
    "
  >
    <ul>
      @for (file of filesList; track file) {
      <li class="pos-relative">
        <div class="file-list">
          <div class="">
            <span class="file-type">
              <!-- <img class="image is-24x24" src="../../../../assets/images/file_types/{{file.file_ext}}.png"> -->
              <!-- <i class="fa fa-picture-o"></i> -->
              <i class="fa fa-paperclip" aria-hidden="true"></i>
            </span>
            <span class="file-name-list" title="{{ file.file_id }}">{{
              file.file_id
            }}</span>
            <!-- <span class="file-download" (click)="secureFileDownLoad(file.download_url, file.file_id)"> -->
            <span class="file-download" (click)="secureFileDownLoad(file)">
              @if (!file.startFileDownLoad) {
              <i class="pi pi-download"></i>
              } @if (file.startFileDownLoad) {
              <i
                class="fa fa-circle-o-notch fa-spin image-download has-text-link"
              ></i>
              }
            </span>
          </div>
          <div class="">
            <span class="is-size-7 text-clr-grey file-date">{{
              file.created_at
            }}</span>
            <span class="file-size text-clr-grey">{{
              file.file_size | fileSize
            }}</span>
          </div>
        </div>
      </li>
      }
      <pagination-loader
        [showFetchLoader]="showPaginateSpinner"
      ></pagination-loader>
      <!-- <li class="pos-relative">
      <div class="file-list">
        <div class="">
          <span class="file-type">
            <i class="fa fa-file-pdf-o"></i>
          </span>
          <span class="file-name-list">File name here test content list new content</span>
          <span class="file-download">
            <i class="pi pi-download"></i>
          </span>
        </div>
        <div class="">
          <span class="is-size-7 text-clr-grey file-date">Mar 31 2018</span>
          <span class="file-size text-clr-grey">328KB</span>
        </div>
      </div>
    </li> -->
    </ul>
  </div>
  } @if (tab_name === 'links') {
  <div
    class="list-wrapper scroll-bar list-overflow file-list-sec file-links"
    appInfiniteScroll
    (reachedBottom)="
      onScrollDown(groupDetail.chat_group_id, userDetail?.user_id, 'links')
    "
  >
    <ul>
      @for (link of linksList; track link) {
      <li class="pos-relative">
        <div class="file-list">
          <div class="">
            <span class="file-type">
              <i class="fa fa fa-link" aria-hidden="true"></i>
            </span>
            <span
              class="file-name-list"
              title="{{ link.http_link }}"
              [innerHTML]="link.http_link | linkify"
            ></span>
          </div>
          <div class="">
            <span class="is-size-7 text-clr-grey file-date">{{
              link.created_at
            }}</span>
          </div>
        </div>
      </li>
      }
      <pagination-loader
        [showFetchLoader]="showPaginateSpinner"
      ></pagination-loader>
    </ul>
  </div>
  } @if (tab_name === 'tasks' ) {
  <div
    class="list-wrapper scroll-bar list-overflow file-list-sec file-tasks"
    appInfiniteScroll
    (reachedBottom)="
      onScrollDown(groupDetail.chat_group_id, userDetail?.user_id, 'tasks')
    "
  >
    <ul class="pinTasks">
      @for (item of tasksList; track item; let i = $index) {
      <li class="pos-relative">
        <div class="file-list" data-target="modal" aria-haspopup="true">
          <div class="">
            <span class="file-type">
              <i class="fa fa fa-thumb-tack" aria-hidden="true"></i>
            </span>
            <span
              class="file-name-list cursor-pointer"
              title=""
              [innerHTML]="item.task | linkify"
              (click)="getTaskDetails(item.pin_id, groupDetail.chat_group_id)"
            ></span>
          </div>
          <div class="">
            <span class="is-size-7 file-name-list"
              >Assigned To : {{ item.assigned_to }}</span
            >
          </div>
          <div class="">
            <span class="is-size-7 file-name-list" data-tooltip="Due Date"
              >Due Date : {{ item.task_due_date }} @if (!item.task_due_date) {
              <i class="fa fa-calendar" aria-hidden="true"></i>
              }
            </span>
            <span
              class="is-size-7 select is-small tag is-light"
              [ngClass]="{
                'is-info': item.status === 0,
                'is-primary': item.status === 1,
                'is-success': item.status === 2,
                'is-danger': item.status === 3
              }"
            >
              <select
                [(ngModel)]="item.status"
                class="is-capitalized"
                (change)="updatePinTaskStatus(item.pin_id, $event)"
                [disabled]="isUserRole == userRole"
              >
                @for (l of taskStatus; track l; let i = $index) {
                <option value="{{ i }}">
                  <span class="tag is-light is-info">{{ l }}</span>
                </option>
                }
              </select>
            </span>
          </div>
        </div>
      </li>
      }
      <pagination-loader
        [showFetchLoader]="showPaginateSpinner"
      ></pagination-loader>
    </ul>
  </div>
  }

  <!-- Add group member buttons -->

  @if (!showMemberList && nonGroupUserList.length > 0) {
  <div class="has-text-centered">
    <a
      class="button is-small is-outlined mar-0-10"
      (click)="cancelNewGroupMemebers()"
      >Cancel</a
    >
    @if (selectedUserIdList.length ===0) {
    <a class="button is-link is-small is-outlined" disabled>Save</a>
    } @if (selectedUserIdList.length > 0) {
    <a
      class="button is-link is-small"
      (click)="saveAddedGroupMembers(groupDetail.chat_group_id)"
      >Save</a
    >
    }
  </div>
  }
</div>

<div class="showAssignment">
  <div
    id="modal"
    class="modal"
    [ngClass]="{ 'is-modal-active': showTaskData[pinId] }"
  >
    <div class="modal-background"></div>
    <div class="modal-content">
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">Assignment</p>
          <button
            class="delete"
            aria-label="close"
            #onClose
            (click)="closeModalTask(pinId)"
          ></button>
        </header>
        <div class="card-content">
          @for (item of tasksDetails; track item) {
          <div class="content">
            <div class="field">
              <div class="content">
                <label class="label">Task </label>
                <span
                  class="file-name-list"
                  title=""
                  [innerHTML]="item.task"
                ></span>
              </div>
            </div>
            <div class="field is-horizontal">
              <div class="field-body">
                <div class="field">
                  <div class="content">
                    <label class="label">Assignment Due Date</label>
                    <span
                      class="file-name-list"
                      [innerHTML]="item.task_due_date"
                    ></span>
                  </div>
                </div>
                <div class="field">
                  <div class="content">
                    <label class="label">Status</label>
                    <span
                      class="is-size-7 select is-small"
                      [ngClass]="{
                        'is-info': item.status == 0,
                        'is-primary': item.status == 1,
                        'is-success': item.status == 2,
                        'is-danger': item.status == 3
                      }"
                    >
                      <select
                        [(ngModel)]="item.status"
                        class="is-capitalized"
                        (change)="updatePinTaskStatus(pinId, $event)"
                        [disabled]="isUserRole == userRole"
                      >
                        @for (status of taskStatus; track status; let i =
                        $index) {
                        <option value="{{ i }}">
                          <span
                            class="tag is-light is-primary"
                            [ngClass]="{
                              'is-info': item.status === 0,
                              'is-primary': item.status === 1,
                              'is-success': item.status === 2
                            }"
                            >{{ status }}</span
                          >
                        </option>
                        }
                      </select>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="field is-horizontal">
              <div class="field-body">
                <div class="field">
                  <div class="content">
                    <label class="label">Assigned By</label>
                    <span class="file-name-list">{{ item.assigned_by }}</span>
                  </div>
                </div>
                <div class="field">
                  <div class="content">
                    <label class="label">Assigned To</label>
                    <span class="file-name-list">{{ item.assigned_to }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
    <button
      class="modal-close is-large"
      #onClose
      (click)="closeModalTask(pinId)"
      aria-label="close"
    ></button>
  </div>
</div>
